import styles from './InputValidationError.module.scss';

type IInputValidationError = {
  message: string;
};

export const InputValidationError = ({message}: IInputValidationError) => {
  return <p className={styles.errorMsg}>{message}</p>;
};
